import {FromJsonToGoogleMapsApiUrlsMapper} from './FromJsonToGoogleMapsApiUrlsMapper.js'

export class LocationMappersFactory {
  /**
   * @return {FromJsonToGoogleMapsApiUrlsMapper}
   */
  static fromJsonToGoogleMapsApiUrlsMapper = ({config}) => {
    return new FromJsonToGoogleMapsApiUrlsMapper({
      config
    })
  }
}
